import { Injectable } from '@angular/core';
import * as jwtDecode from 'jwt-decode';

const KEY = 'token';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  isTokenValido() {
    const token = this.retornarToken();
    if (token == '') {
      return false;
    }
    const tokenDecoded = jwtDecode(token);
    return !(tokenDecoded.exp < (Date.now() / 1000));
  }

  salvarToken(token: string) {
    return localStorage.setItem(KEY, token);
  }

  excluirToken(): void {
    localStorage.removeItem(KEY);
  }

  retornarToken(): string {
    return localStorage.getItem(KEY) != null ? localStorage.getItem(KEY) : '';
  }


}
